
import { Loader2 } from "lucide-react";

const InsightLoading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Loader2 className="w-8 h-8 animate-spin text-nation-blue" />
    </div>
  );
};

export default InsightLoading;
